import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import * as styles from './CommentWarning.module.scss';
import alertIcon from '../../icons/non-prefilled/16x16/alert.svg';

interface CommentWarningProps {
  children: React.ReactNode;
}

const CommentWarning = ({ children }: CommentWarningProps) => {
  return (
    <div className={styles.container}>
      <SVGIcon className={styles.icon} size="small">
        {alertIcon}
      </SVGIcon>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default CommentWarning;
